module.exports = __webpack_public_path__ + "static/media/Seagul.f53cd750.mp3";